import AuthCall from './auth';

export default {
  // loadRemoteTracker: async (trackerId) => {
  //   return await AuthCall.get(`/api/v1/secure/tracker/instance/${trackerId}`);
  // },
  loadRemoteTracker: async (trackerId) => await AuthCall.get(`/api/v1/secure/tracker/instance/${trackerId}`),
}